module.exports = __webpack_public_path__ + "img/school_icn.f282b80d.png";